import React from "react";
import NavbarItems from "./NavbarItems";
import SidebarItems from "../sidebar/sidebarItems";
import "./navbar.css";
import logo from "../../logo/logo.png";
import { Link as RouterLink } from "react-router-dom";
import { useEffect, useState } from "react";
import { Image } from "@chakra-ui/image";
import { Text, Link, Box } from "@chakra-ui/react";
import { AiFillCaretUp, AiFillCaretDown } from "react-icons/ai";

function Navbar(props) {
  const [width, setWidth] = useState(window.innerWidth);
  const [selectedSubMenu, setSelectedSubMenu] = useState("");

  //to check width of the page
  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return (_) => {
      window.removeEventListener("resize", handleResize);
    };
  }, [width]);
  const handleClick = (title) => {
    if (title === selectedSubMenu) {
      setSelectedSubMenu("");
    } else {
      setSelectedSubMenu(title);
    }
  };
  return (
    <>
      <nav className="NavbarItems">
        <div className="navbar-left">
          <div className="navbar-logo">
            <Link
              to="/"
              cursor="pointer"
              as={RouterLink}
              style={{ textDecoration: "none" }}
              _focus={{
                boxShadow: "none",
              }}
            >
              <Image src={logo} alt="qatar university logo" />
            </Link>
          </div>
          <div>
            <Text className="navbar-logo-title">
              Qatar University <br />
              Machine Learning Group
            </Text>
          </div>
        </div>

        <div className="navbar-right">
          <div
            className="menu-icon"
            onClick={() => props.setIsMenuOpen(!props.isMenuOpen)}
          >
            <i
              className={props.isMenuOpen ? "fas fa-times" : "fas fa-bars"}
            ></i>
          </div>
          <ul className={props.isMenuOpen ? "nav-menu active" : "nav-menu"}>
            {width <= 1078 ? (
              <>
                {SidebarItems.map((item) => {
                  return (
                    <div key={item.id}>
                      <Box
                        transition="all 0.3s ease"
                        _hover={{
                          bgColor: "#1a2963",
                          color: "white",
                        }}
                        cursor="pointer"
                      >
                        <Box
                          display="flex"
                          justifyContent="space-between"
                          onClick={() => {
                            handleClick(item.title);
                          }}
                        >
                          {!!item.subMenu ? (
                            <Box padding="1rem">
                              <Text fontSize="16px">{item.title}</Text>
                            </Box>
                          ) : (
                            <Link
                              padding="1rem"
                              to={item.url}
                              as={RouterLink}
                              width="100%"
                              _focus={{
                                boxShadow: "none",
                              }}
                              style={{ textDecoration: "none" }}
                              onClick={() =>
                                props.setIsMenuOpen(!props.isMenuOpen)
                              }
                            >
                              <Text textAlign="left">{item.title} </Text>
                            </Link>
                          )}
                          {item.subMenu && (
                            <Box alignItems="center">
                              {selectedSubMenu === item.title ? (
                                <Box padding="1rem">
                                  <AiFillCaretUp />
                                </Box>
                              ) : (
                                <Box padding="1rem">
                                  <AiFillCaretDown />
                                </Box>
                              )}
                            </Box>
                          )}
                        </Box>
                      </Box>

                      {item.title === selectedSubMenu ? (
                        item.subMenu?.map((items) => {
                          return (
                            <Box
                              key={items.id}
                              transition="all 0.3s ease"
                              onClick={() => {
                                props.setIsMenuOpen(!props.isMenuOpen);
                              }}
                              _hover={{
                                bgColor: "#1a2963",
                                color: "white",
                              }}
                            >
                              <Link
                                to={items.url}
                                as={RouterLink}
                                _focus={{
                                  boxShadow: "none",
                                }}
                                style={{ textDecoration: "none" }}
                              >
                                <Box padding="1rem">
                                  <Text>{items.title} </Text>
                                </Box>
                              </Link>
                            </Box>
                          );
                        })
                      ) : (
                        <></>
                      )}
                    </div>
                  );
                })}
              </>
            ) : (
              NavbarItems.map((item, index) => {
                return (
                  <li key={item.id}>
                    <a className={item.cname} href={item.url}>
                      {item.title}
                    </a>
                  </li>
                );
              })
            )}
          </ul>
        </div>
      </nav>
    </>
  );
}

export default Navbar;
